import moment from 'moment';

const maxTextInputCharactersLength = 120;
const phoneMask = [
  '(',
  /\d/,
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

// TODO: will be removed after input international implementation
const phoneMaskSpain = [
  '(',
  '+',
  '3',
  '4',
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
];
const phoneMaskSpainView = [
  '(',
  '+',
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
];
const einMask = [/\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
const ssnMask = [
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];
const codeMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/];

const validateNoPastTime = (dateTime: Date | null) => {
  if (!dateTime) return true;

  const timeWithoutSeconds = moment(dateTime).seconds(0).milliseconds(0);
  const currentTimeWithoutSeconds = moment(new Date())
    .seconds(0)
    .milliseconds(0);

  return timeWithoutSeconds.isSameOrAfter(currentTimeWithoutSeconds);
};

const validateNoEndDateLessStartDate = (
  startDate: Date | string,
  endDate: Date | string,
) => {
  const startDateWithoutHours = moment(startDate)
    .hours(0)
    .minutes(0)
    .seconds(0)
    .milliseconds(0);

  const endDateWithoutHours = moment(endDate)
    .hours(0)
    .minutes(0)
    .seconds(0)
    .milliseconds(0);

  return startDateWithoutHours.isSameOrBefore(endDateWithoutHours);
};

const isFieldValuesLengthValid = (values: string[], maxLength: number) => {
  const isLengthValid = values.every((value) => value.length <= maxLength);

  return isLengthValid;
};

const isMatchRegExp = (regexp: RegExp, inputValue: string): boolean => {
  return regexp.test(inputValue);
};

/**
 * Validates that an email is unique among other recipient emails and owner email
 * @param value - The email value to validate
 * @param otherEmails - Array of other email values to check against
 * @param ownerEmail - Owner email to check against
 * @returns Error message string if validation fails, undefined if email is valid or empty
 */
const validateUniqueRecipientEmail = (
  value: string | null | undefined,
  otherEmails: (string | null | undefined)[],
  ownerEmail?: string | null | undefined,
): string | undefined => {
  if (!value || value.trim().length === 0) return undefined;

  const trimmedValue = value.trim().toLowerCase();
  const trimmedOwnerEmail = ownerEmail?.trim().toLowerCase();

  // Check against owner email
  if (trimmedOwnerEmail && trimmedValue === trimmedOwnerEmail) {
    return 'Please enter an email address different from the Company Representative email for Activity Reports';
  }

  // Check against other recipient emails
  for (const otherEmail of otherEmails) {
    if (otherEmail) {
      const trimmedOtherEmail = otherEmail.trim().toLowerCase();
      if (trimmedValue === trimmedOtherEmail) {
        return 'The recipient email must be unique';
      }
    }
  }

  return undefined;
};

export {
  ssnMask,
  einMask,
  phoneMask,
  phoneMaskSpain,
  validateNoPastTime,
  isFieldValuesLengthValid,
  validateNoEndDateLessStartDate,
  phoneMaskSpainView,
  maxTextInputCharactersLength,
  isMatchRegExp,
  codeMask,
  validateUniqueRecipientEmail,
};
